import { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { getClientsList } from "../../../services/client";
import { getWastecategoryList } from "../../../services/waste";
import { countContainers } from "../../../services/container";
import { getSettingsData } from "../../../services/settings";

export const useSettingsCounts = () => {
  const [counts, setCounts] = useState({
    sites: null,
    clients: null,
    waste: null,
    containers: null,
    cameras: null,
    contacts: null,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const API = process.env.REACT_APP_API_BACKEND;
    const token = Cookies.get("userToken");

    const fetchCounts = async () => {
      try {
        const [
          sitesResponse,
          clientsResponse,
          wasteResponse,
          containersResponse,
          camerasResponse,
          settingsResponse,
        ] = await Promise.allSettled([
          axios.get(`${API}address?page=1&limit=1`, {
            headers: { authorization: `Bearer ${token}` },
            params: {
              keywordFilter: "",
              listPostalCodeFilter: {},
              listCityFilter: {},
              sortByField: "name",
              orderSortByField: "1",
              listRoleFilter: {},
            },
          }),
          getClientsList(),
          getWastecategoryList({
            keywordFilter: "",
            listUnCodeFullFilter: {},
            listUnCodeEmptyFilter: {},
            listWasteCodeFullFilter: {},
            listWasteCodeEmptyFilter: {},
            sortByField: "label",
            orderSortByField: "1",
          }),
          countContainers({ keywordFilter: JSON.stringify([]) }),
          axios.get(`${API}cameras`, {
            headers: { authorization: `Bearer ${token}` },
            params: {
              all: false,
              keywordFilter: "",
              sortByField: "name",
              orderSortByField: "1",
              batteryLevelFilter: [0, 100],
              startDateFilter: null,
              stopDateFilter: null,
              listAddressFilter: {},
              page: 1,
              limit: 10000,
            },
          }),
          getSettingsData(),
        ]);

        setCounts({
          sites:
            sitesResponse.status === "fulfilled" &&
            sitesResponse.value.status === 200
              ? sitesResponse.value.data.count || 0
              : 0,
          clients:
            clientsResponse.status === "fulfilled" &&
            clientsResponse.value.status === 200
              ? clientsResponse.value.data.data?.length || 0
              : 0,
          waste:
            wasteResponse.status === "fulfilled" &&
            wasteResponse.value.status === 200
              ? wasteResponse.value.data.data?.length || 0
              : 0,
          containers:
            containersResponse.status === "fulfilled" &&
            containersResponse.value.status === 200
              ? containersResponse.value.data.count || 0
              : 0,
          cameras:
            camerasResponse.status === "fulfilled" &&
            camerasResponse.value.status === 200
              ? (camerasResponse.value.data.dataCamerasList || []).filter(
                  (camera) =>
                    camera?.status !== "virtual" &&
                    !String(camera?.name || "")
                      .toLowerCase()
                      .includes("mobile"),
                ).length
              : 0,
          contacts:
            settingsResponse.status === "fulfilled" &&
            settingsResponse.value.status === 200
              ? settingsResponse.value.data.contractList?.length || 0
              : 0,
        });
      } catch (error) {
        console.error("Error fetching settings counts:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      fetchCounts();
    }
  }, []);

  return { counts, isLoading };
};
